module.exports = __webpack_public_path__ + "static/img/service-row3.5f8ba7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/service-row3.png
// module id = MLTU
// module chunks = 1